<div class="mat-dialog-alert tw-flex tw-flex-col tw-w-full">

  <!-- Header — same blue ribbon used by WagerConfirmDialog & MatConfirmDialog -->
  <div
    class="
      modal-header
      tw-flex
      tw-items-center
      tw-justify-between
      tw-bg-[#1B478A]
      tw-text-[#FFFFFF]
      tw-rounded-t-[12px]
      tw-px-[16px]
      tw-py-[14px]
      tw-gap-[10px]
    "
    [ngClass]="severityHeaderClass"
  >
    <div class="tw-flex tw-items-center tw-gap-[10px] tw-min-w-0">
      <mat-icon
        class="severity-icon !tw-text-white !tw-flex !tw-items-center !tw-justify-center"
        aria-hidden="true"
      >
        {{ severityIcon }}
      </mat-icon>
      <p
        class="
          modal-title
          tw-text-[18px]
          tw-font-bold
          tw-mb-0
          tw-uppercase
          tw-truncate
        "
      >
        {{ data.title }}
      </p>
    </div>

    <button
      type="button"
      mat-icon-button
      (click)="onClose()"
      aria-label="Close"
      class="close-icon !tw-text-white"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div
    class="
      modal-body
      tw-bg-white
      tw-px-[20px]
      tw-py-[18px]
      tw-text-center
    "
  >
    @if (data.subtitle) {
      <p
        class="
          modal-subtitle
          tw-text-[#0E2543]
          tw-text-[16px]
          tw-font-semibold
          tw-mb-[10px]
        "
      >
        {{ data.subtitle }}
      </p>
    }

    <p
      class="
        modal-message
        tw-text-[#0E2543]
        tw-text-[15px]
        tw-leading-[1.45]
        tw-mb-0
        tw-whitespace-pre-line
      "
    >
      {{ data.message }}
    </p>
  </div>

  <!-- Footer / actions -->
  @if (data.actionPositiveText || data.actionNegativeText) {
    <div
      class="
        modal-actions
        tw-flex
        tw-justify-between
        tw-gap-[12px]
        tw-bg-white
        tw-rounded-b-[12px]
        tw-px-[20px]
        tw-pb-[18px]
      "
    >
      @if (data.actionNegativeText) {
        <button
          type="button"
          mat-stroked-button
          color="warn"
          class="cancel-btn !tw-flex-1 !tw-rounded-full"
          (click)="onClose()"
        >
          {{ data.actionNegativeText }}
        </button>
      }
      @if (data.actionPositiveText) {
        <button
          type="button"
          mat-flat-button
          color="primary"
          class="submit-btn !tw-flex-1 !tw-rounded-full tw-whitespace-nowrap"
          (click)="onSubmit(true)"
        >
          {{ data.actionPositiveText }}
        </button>
      }
    </div>
  } @else {
    <!--
      Callers that fire showAlert() without any positive/negative
      label still need a clean rounded-bottom edge so the body
      doesn't butt up against the dialog surface — match the
      footer's bottom padding so the visual rhythm is preserved.
    -->
    <div class="modal-actions-spacer tw-bg-white tw-rounded-b-[12px] tw-pb-[18px]"></div>
  }

</div>
